import { View } from "react-native";
import { GatheringPreviewRowItemType } from "src/components/GatheringPreviewRow/types";
import ImpactBackgroundGradient from "src/components/ImpactBackgroundGradient";
import { DEFAULT_IMPACT_BACKGROUND_GRADIENT } from "src/components/ImpactBackgroundGradient/constants";
import parseV0TemplateUrl from "src/helpers/parseV0TemplateUrl";
import usePalette from "src/hooks/usePalette";
import { paddingSmall } from "src/styles/spacing";
import { Image } from "src/swsh-native";

const BORDER_RADIUS = 1000;
const ASPECT_RATIO = 1;
const GatheringThumbnailPreview = ({
	gathering,
	preferPalette = false,
}: {
	gathering: GatheringPreviewRowItemType;
	/**
	 * Usually the ring color is based on the album's palette but if `preferPalette` is true
	 * then we use the current palette context (e.g. a group's palette) instead.
	 * @default false
	 */
	preferPalette?: boolean;
}) => {
	const { primary, isFallback } = usePalette();
	const thumbnailUrl = parseV0TemplateUrl({
		readUrl: gathering?.thumbnail?.readUrl,
		aspectRatio: "1x1",
		size: "sm",
		strategy: "cover",
	});

	if (!thumbnailUrl) return null;
	return (
		<View
			pointerEvents="none"
			style={{
				maxHeight: "80%",
				maxWidth: "30%",
				height: "100%",
				aspectRatio: 1,
				justifyContent: "center",
			}}
		>
			{preferPalette ? (
				<View
					style={{
						backgroundColor: isFallback
							? DEFAULT_IMPACT_BACKGROUND_GRADIENT.baseColor
							: primary,
						aspectRatio: ASPECT_RATIO,
						borderRadius: BORDER_RADIUS,
						padding: paddingSmall,
					}}
				>
					<Image
						recyclingKey={gathering.gatheringId}
						alt="Album cover photo"
						src={thumbnailUrl}
						dim="auto"
						style={{
							flex: 1,
							borderRadius: 1000,
						}}
						contentFit="cover"
					/>
				</View>
			) : (
				<ImpactBackgroundGradient
					palette={gathering.palette}
					style={{
						aspectRatio: ASPECT_RATIO,
						borderRadius: BORDER_RADIUS,
						padding: paddingSmall,
					}}
				>
					<Image
						recyclingKey={gathering.gatheringId}
						alt="Album cover photo"
						src={thumbnailUrl}
						dim="auto"
						style={{
							flex: 1,
							borderRadius: BORDER_RADIUS,
						}}
						contentFit="cover"
					/>
				</ImpactBackgroundGradient>
			)}
		</View>
	);
};
export default GatheringThumbnailPreview;
